import React from 'react';
import { motion } from 'framer-motion';
import ContactForm from '../components/ContactFormElevated';
import ParallaxBackground from '../components/ParallaxBackground';
import { FiPhone } from 'react-icons/fi';

const ResidentialSellers = () => {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      className="min-h-screen"
    >
      <ParallaxBackground 
        image="/images/boathouse-row.jpg"
        className="py-32"
        overlay={true}
      >
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="text-5xl md:text-6xl font-bold mb-6 text-white">
            Residential Sellers
          </h1>
          <p className="text-xl md:text-2xl text-gray-200 max-w-3xl mx-auto">
            Comprehensive closing services for homeowners selling their property
          </p>
        </div>
      </ParallaxBackground>

      <section className="py-16 bg-eagle-light-gray">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-4xl font-bold text-eagle-dark mb-4">
              Residential Sellers Services
            </h2>
            <p className="text-lg text-gray-600 max-w-3xl mx-auto">
              Selling a home is a significant milestone, and a smooth closing is crucial to ensure a successful transaction. At Eagle Closing, we specialize in providing comprehensive closing services tailored specifically to residential sellers. Our experienced team is dedicated to facilitating a seamless and efficient closing experience for homeowners like you.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {[
              {
                title: 'Expert Guidance',
                description: 'Selling a home involves various legal and logistical considerations. Our team provides expert guidance and support throughout the entire closing process. We\'ll walk you through each step, answer your questions, and ensure you have a clear understanding of the closing process.',
              },
              {
                title: 'Contract Review',
                description: 'Our professionals meticulously review the sales agreement, ensuring that all terms and conditions align with your expectations. We\'ll explain any legal jargon or clauses, helping you make informed decisions.',
              },
              {
                title: 'Title Examination and Insurance',
                description: 'We conduct a thorough title examination to ensure the property has a clear title, free from any liens or claims that could hinder the sale. Additionally, we assist in obtaining title insurance, providing protection and peace of mind to potential buyers regarding the property\'s ownership.',
              },
              {
                title: 'Document Preparation and Review',
                description: 'We handle the preparation and review of all closing documents, including the deed, bill of sale, and closing statements. Our attention to detail ensures that all documents are accurate and compliant with legal requirements.',
              },
              {
                title: 'Coordination and Communication',
                description: 'We act as a central point of contact between all parties involved in the transaction, including real estate agents, buyers, and attorneys. We facilitate clear communication and timely exchange of information to ensure a smooth and efficient closing process.',
              },
              {
                title: 'Timely and Efficient Closings',
                description: 'We understand the importance of meeting deadlines. With our streamlined processes and commitment to efficiency, we work diligently to ensure that your closing is conducted in a timely manner, allowing you to move forward with your plans.',
              },
            ].map((service, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: index * 0.1 }}
                className="bg-white p-6 rounded-lg shadow-md hover:shadow-lg transition-shadow"
              >
                <h3 className="text-xl font-semibold text-eagle-dark mb-3">
                  {service.title}
                </h3>
                <p className="text-gray-600">
                  {service.description}
                </p>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-8">
            <p className="text-lg text-gray-700 mb-8">
              At Eagle Closing, we are committed to providing exceptional service and support to residential sellers. We strive to make the closing process as stress-free and seamless as possible, allowing you to focus on your next chapter.
            </p>
            <p className="text-lg text-gray-700 mb-8">
              Contact us today to learn more about our residential seller services and how we can assist you in achieving a successful closing. Trust Eagle Closing to be your dedicated partner throughout the selling process, ensuring a smooth transition to the next phase of your life.
            </p>
          </div>
        </div>
      </section>
      
      {/* Contact Form with Parallax */}
      <ContactForm backgroundImage="/images/benjamin-franklin-bridge.jpg" />
    </motion.div>
  );
};

export default ResidentialSellers;

